import Vue                  from 'vue'
import Router               from 'vue-router'
import RestaurantSelectPage from '@/components/RestaurantSelectPage'
import AlertsPage           from '@/components/AlertsPage'

import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'RestaurantSelectPage',
      component: RestaurantSelectPage
    },
    {
      path: '/alerts',
      name: 'AlertsPage',
      secure: true,
      component: AlertsPage
    }
    
  ]
})

router.beforeEach((to, from, next) => {
  router.options.routes.forEach((route) => {
    if (to.matched[0].path === route.path && route.secure) {

      const restId = store.getters['alerts/getRestId']
      return !restId ? next('/') : next()
  
    }
  })
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js